﻿import {AddToComparisonModel, ProductComparisonAddRemoveResponse} from "@/interfaces"
import {get, $, $$, postDataJson, postData, show, hide, getData, toggle} from "@/Utils"
import {StatusCodes} from "http-status-codes";


function togglePanelComparisonLink(resp: ProductComparisonAddRemoveResponse) {
    // Toggle "Show Comparisons" in login panel. Feature for logged in users.
    const panelComparisonProducts = get("panel-comparison-products")
    if (!panelComparisonProducts) return;
    if (resp.comparisonUrl) {
        panelComparisonProducts.querySelector("a").href = resp.comparisonUrl;
        show(panelComparisonProducts);
    } else {
        hide(panelComparisonProducts)
    }
}

function deactivateAddRemoveButton(dataRemoveId: string) {
    const addRemoveButton = $(`[data-add-remove-id='${dataRemoveId}']`)
    if (addRemoveButton) {
        addRemoveButton.classList.remove("tooltip__button--active")
    }
}

export function initComparisonPartial() {
    const comparisonFooter = get("comparison-footer");
    if (!comparisonFooter) {
        return;
    }

    const comparisonInteractors = comparisonFooter.querySelectorAll("[data-remove-id]");
    comparisonInteractors.forEach(x => x.addDataBoundEventListener("click", () => {
        const dataRemoveId = x.getAttribute("data-remove-id");
        highlightProductCard(dataRemoveId, false, "is-in-comparison");
        $(`[data-card-add-remove-id='${dataRemoveId}'] .product-card-icons.active`)?.classList.remove("active");
        deactivateAddRemoveButton(dataRemoveId);
        const callback = (resp: ProductComparisonAddRemoveResponse) => {
            if (resp.comparisonFooter) {
                comparisonFooter.innerHTML = resp.comparisonFooter;
            }
            togglePanelComparisonLink(resp);
            toggleComparisonFooterIfRemovingLast(false)
        };
        postDataJson(window.config.addRemoveComparisonUrl, {
            id: parseInt(dataRemoveId),
            add: false
        } as AddToComparisonModel, callback);
    }));

}

export function addRemoveComparison(add: boolean, productId: number) {
    const comparisonFooter = get("comparison-footer");
    const request: AddToComparisonModel = {id: productId, add: add};
    const callback = (resp: ProductComparisonAddRemoveResponse) => {
        if (resp.message) {
            const comparisonMessageContainer = get("comparison-message-container");
            const cookieConsentBlock = get("cookieConsentBlock");
            if (cookieConsentBlock)
                comparisonMessageContainer.style.top = `${cookieConsentBlock.offsetHeight}px`;
            comparisonMessageContainer.innerHTML = resp.message;
            return;
        }
        if (resp.comparisonFooter) {
            comparisonFooter.innerHTML = resp.comparisonFooter;
            initComparisonPartial();
            toggleComparisonFooterIfRemovingLast(add)
        }
        togglePanelComparisonLink(resp);
    };
    postDataJson(window.config.addRemoveComparisonUrl, request, callback);
}

function toggleComparisonFooter(force = null) {
    const footer = get("comparison-footer");
    if (force !=null){
        return footer.classList.toggle("comparison-footer__container--active", force);
    }
    return footer.classList.toggle("comparison-footer__container--active");
}

export function getAlreadyInComparison() {
    return  $$(".comparison-sticky__item").length
}
export function toggleComparisonFooterIfRemovingLast(add: boolean) {
    const removedLast = getAlreadyInComparison() == 0 && !add;
    if (removedLast) {
        toggleComparisonFooter(false);
    } else {
        toggleComparisonFooter(true);
    }
}

export function initComparisons() {
    $$("[data-add-remove-id]").forEach(x => {
        if (x.hasAttribute("data-bound")) {
            return;
        }
        x.setAttribute("data-bound", "true");
        x.addEventListener("click", () => {
            const add = x.classList.toggle("tooltip__button--active");
            const productId = parseInt(x.getAttribute("data-add-remove-id"));
            addRemoveComparison(add, productId);
            if (getAlreadyInComparison() < 4 || !add) {
                highlightProductCard(productId.toString(), add, "is-in-comparison");
            } else if (add) {
                x.classList.toggle("tooltip__button--active");
            }
        });
    });
    initComparisonPartial();
}

export function initFavorites() {
    $$("[data-favorite-id]").forEach(x => {
        x.addDataBoundEventListener("click", () => {
            const add = x.classList.toggle("tooltip__button--active");
            const productId = parseInt(x.getAttribute("data-favorite-id"));
            const url = add ? window.config.addFavoriteUrl : window.config.removeFavoriteUrl;
            const callback = (resp: Response) => {
                toggle(get("panel-saved-products"), resp.status !== StatusCodes.NO_CONTENT)
            };
            postData(url, productId, callback)
            highlightProductCard(productId.toString(), add, "is-favorite");
        });
    });
}

export function highlightProductCard(productId: string, add: boolean, cssClass: string) {
    const productCardContainer = $(`[data-product-id='${productId}']`);
    if (add) {
        productCardContainer?.classList.add(cssClass);
    } else {
        productCardContainer?.classList.remove(cssClass);
    }
}

export function initToggleComparisonFooter() {
    $(".comparison-footer__toggle")?.addDataBoundEventListener("click", () => {
        const show = toggleComparisonFooter()
        postData(window.config.toggleComparisonUrl, show);
    });
}

export function initClearComparison() {
    get("clear-comparison")?.addDataBoundEventListener("click", () => {
        get("comparison-footer").innerHTML = "";
        $$("[data-add-remove-id].tooltip__button--active").forEach(x => {
            x.classList.remove("tooltip__button--active");
            const productId = x.getAttribute("data-add-remove-id");
            highlightProductCard(productId, false, "is-in-comparison")
        });
        // Deactivate toggle button in product detail view.
        get("comparisonToggle")?.classList.remove("active")
        getData(window.config.clearComparisonUrl);
    })
}